import React, { useState, useEffect } from 'react';
import { Nav, NavItem, NavLink, Col } from 'reactstrap';
import ComponentCard from '../../layouts/containers/ComponentCard';
import PestañasDatos from './PestañasDatos';
import Matriculaciones from './Matriculaciones';
import Ciclos from './Ciclos';
import alumnosApiService from '../../services/http/alumnosApiService';
import recibosApiService from '../../services/http/recibosApiService';
import useAuth from '../../hooks/useAuth';
import logger from '../../services/logger';

const Detalles = () => {
  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const { getStudent } = useAuth();
  const student = getStudent() || {};
  const { id, empresaId } = student;
  const [dataApi, setDataApi] = useState('');
  const [dataFacturas, setDataFacturas] = useState('');
  const [dataRecibos, setDataRecibos] = useState('');

  const fetchRecibosData = async () => {
    setDataRecibos('');
    try {
      const data = await recibosApiService.cargarRecibosPortal({
        idAlumno: id,
        headquarter: empresaId,
      });
      setDataRecibos(Array.isArray(data) ? data : []);
    } catch (error) {
      // null = error de carga (distinto de [] = sin recibos): la pestaña avisa
      // y ofrece reintentar en vez de decir "no hay recibos".
      logger.error('Error al cargar los recibos del alumno:', error);
      setDataRecibos(null);
    }
  };

  useEffect(() => {
    const fetchAlumnoData = async () => {
      try {
        const data = await alumnosApiService.cargarAlumno({ id, headquarter: empresaId });
        setDataApi(data);
      } catch (error) {
        setDataApi('');
      }
    };

    const fetchFacturasData = async () => {
      try {
        const data = await alumnosApiService.cargarFacturasPortal({
          idAlumno: id,
          headquarter: empresaId,
        });
        setDataFacturas(data);
      } catch (error) {
        setDataFacturas('');
      }
    };

    fetchAlumnoData();
    fetchFacturasData();
    fetchRecibosData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Col md="12">
        <ComponentCard title="Gestión de usuario">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === '1' ? 'active' : ''}
                onClick={() => {
                  toggle('1');
                }}
              >
                Datos Alumno
              </NavLink>
            </NavItem>
            {dataApi !== '' && dataApi.datos.tutores[0].parentesco === '(Sin Tutores)' ? (
              ''
            ) : (
              <NavItem>
                <NavLink
                  className={activeTab === '2' ? 'active' : ''}
                  onClick={() => {
                    toggle('2');
                  }}
                >
                  Datos tutores
                </NavLink>
              </NavItem>
            )}
            <NavItem>
              <NavLink
                className={activeTab === '3' ? 'active' : ''}
                onClick={() => {
                  toggle('3');
                }}
              >
                Facturas
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === '4' ? 'active' : ''}
                onClick={() => {
                  toggle('4');
                }}
              >
                Recibos
              </NavLink>
            </NavItem>
          </Nav>
          <PestañasDatos
            activeTab={activeTab}
            dataApi={dataApi}
            dataFacturas={dataFacturas}
            dataRecibos={dataRecibos}
            onRecargarRecibos={fetchRecibosData}
          />
        </ComponentCard>
        {dataApi !== '' && dataApi.matriculas.length > 0 ? (
          <Matriculaciones matriculas={dataApi.matriculas} />
        ) : (
          ''
        )}

        {dataApi !== '' && dataApi.ciclos.length > 0 ? (
          <Ciclos datos={dataApi.datos} ciclos={dataApi.ciclos} />
        ) : (
          ''
        )}
      </Col>
    </>
  );
};

export default Detalles;
